<!-- 渠道书库下载任务 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;">渠道书库下载任务</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 5px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			<div class="screen-box">
				<div class="screen-label">作品来源</div>
				<a-select
				    style="min-width: 180px"
				    placeholder="请选择作品来源"
				    @change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="1">阳光</a-select-option>
					<a-select-option value="2">文鼎</a-select-option>
					<a-select-option value="4">万读</a-select-option>
					<a-select-option value="5">阅文</a-select-option>
					<a-select-option value="6">常读</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">状态</div>
				<a-select
				    style="min-width: 180px"
				    placeholder="请选择同步状态"
				    @change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				>
					<a-select-option value="0">未开始</a-select-option>
					<a-select-option value="1">进行中</a-select-option>
					<a-select-option value="2">已完成</a-select-option>
					<a-select-option value="3">失败</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary"  class="screen-box" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="addDown" class="screen-box" type="primary">新建下载任务</a-button>
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				{{rableTitle[0].title}}
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				{{rableTitle[1].title}}
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			@click="sortClick(index)">
				{{item.title}}
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			
			<div  class="table-td-cell"
			:style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<div  class="table-td-cell"
			:style="{'width':rableTitle[1].width + 'px'}">
				{{item.name}}
			</div>
			
		</div>
		
		<!-- 渠道书城 -->
		<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
			{{item.source}}
		</div>
		<!-- 作品三方ID -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
			{{item.book_id}}
		</div>
		<!-- 状态 -->
		<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
			{{item.status_text}}
		</div>
		<!-- 备注 -->
		<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}">
			{{item.remark}}
		</div>
		<!-- 下载地址 -->
		<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}">
			<div @click="downButton(item)" style="color: #62a8ea;cursor: pointer;margin-right: 11px;">下载</div>
		</div>
		<!-- 创建时间 -->
		<div class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}" style="display: flex;flex-wrap: wrap;">
			{{item.created_at}}
		</div>
		<!-- 更新时间 -->
		<div class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}" style="display: flex;flex-wrap: wrap;">
			{{item.updated_at}}
		</div>
		
		
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	
	
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_scroll_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
		</div>
	</div>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`新建作品下载任务`"
	      :visible="edit_visible"
	      :confirm-loading="edit_confirmLoading"
		  cancelText="取消"
		  okText="确认" 
		  width="600px" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
		  
	    >
		<div class="form-cell-box">
			<div class="class-title">作品来源</div>
			<a-select
			    style="min-width: 340px"
			    placeholder="请选择作品来源"
			    @change="handleChangeE"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="x_source"
				allowClear
			>
				<a-select-option value="1">阳光</a-select-option>
				<a-select-option value="2">文鼎</a-select-option>
				<a-select-option value="4">万读</a-select-option>
				<a-select-option value="5">阅文</a-select-option>
				<a-select-option value="6">常读</a-select-option>
			</a-select>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title" >作品链接</div>
				
			<a-input v-model="x_url" style="width: 340px;" placeholder="请输入" />
		</div>
		
		<div class="form-cell-box" style="margin-top: -10px;">
			<div class="class-title" ></div>
			<div v-show="x_source == '1'">
				<div>作品链接说明</div>
				<div style="word-break: break-all;">阳光：详情页链接，例如：https://wx17b9970cc9e73b10.zhixuaw.cn/index/book/info?book_id=11010112678</div>
			</div>
			<div v-show="x_source == '2'">
				<div>作品链接说明</div>
				<div style="word-break: break-all;">文鼎：阅读页链接，例如：https://mbsz.susucheng.cn/book/reader.do?sourceUuid=np_c3sEKZtCi36u_z8pJzh4yUXacPj5MyF9anzJQYp-r_g-cHsEKQ&articleUuid=np_a3cucZwfiRio-TgmK2tCyUjbcKuUPg</div>
			</div>
			<div v-show="x_source == '4'">
				<div>作品链接说明</div>
				<div style="word-break: break-all;">万读：详情页链接，例如：https://w1923.3xiaoshuo.cn/book/detail/48912?loc=2070000</div>
			</div>
			<div v-show="x_source == '5'">
				<div>作品链接说明</div>
				<div style="word-break: break-all;">阅文：阅读页链接，例如：https://wx6425437af159eb21.wxcp.qidian.com/wxfxqx37343/read.html?cbid=14392855605735206&event_id=wx_A06&advid=2333113&infrom=2333113</div>
			</div>
			<div v-show="x_source == '6'">
				<div>作品链接说明</div>
				<div style="word-break: break-all;">常读：阅读页链接，例如：https://novel.snssdk.com/page/novelsale/reader?aid=10003650&book_id=7011182121607760927&enter_from=ad_link&item_id=7011298821527306755</div>
			</div>
		</div>
		
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { libraryDownList, libraryDownAdd, downTaskSelect } from '@/request/api'
export default {
	name: 'libraryDown_',
	data() {
		return {
			table_scroll_width: 2600,
			
			r_limit: 50,
			r_page: 1,
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:80, type:"id",sort_control: false, }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"任务名称",width:200, type:"name",sort_control: false,},
				{title:"渠道书城",width:120, type:"source",sort_control: false,},
				{title:"作品三方ID",width:160, type:"book_id",sort_control: false, },
				{title:"状态",width:100, type:"status_text",sort_control: false, },
				{title:"备注",width:150, type:"remark",sort_control: false, },
				{title:"下载地址",width:100, type:"",sort_control: false, },
				{title:"创建时间",width:150, type:"created_at",sort_control: false, },
				{title:"更新时间",width:150, type:"updated_at",sort_control: false,},
			],
			tableShowData: [],
			table_total: 0,
			
			search_button_loading: false, // 搜索按钮的加载状态
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			
			visible: false,
			
			body_width: 1800, // body的宽度
			
			r_channel_id: "", // 作品来源/渠道
			r_status: "", // 状态
			
			// 单个新增弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			edit_confirmLoading: false,
			x_source: undefined, // 新增-作品书城
			x_url: "", // 新增-作品链接
		}
	},
	mounted(){
		let that = this
		that.body_width = document.body.clientWidth - 60
		console.log("that.body_width",that.body_width);
		
		
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		console.log(that.table_scroll_width)
		
		
		
		that.searchButton()
		
	},
	methods:{
		// 单个日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			
			this.endTime = dateString
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 作品来源
		handleChangeB(e){
			console.log(e);
			this.r_channel_id = e
			
		},
		// 同步状态
		handleChangeD(e){
			this.r_status = e
			
		},
		// 新建任务弹窗-作品来源
		handleChangeE(e){
			this.x_source = e
		},
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				channel_id: that.r_channel_id, // 作品来源/渠道
				status: that.r_status, // 状态
			}
			
			libraryDownList(r_data).then(res=>{
				console.log("搜索结果",res)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.search_button_loading = false
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton()
		},
		
		
		downButton(item){
			console.log(item);
			// window.location.href = 'https://'+item.url
			// window.open('https://'+item.url, '_blank')
			// window.open('https://wx-admin.test.gzlize.com/exports/35da5d0cf929ff30ec9485e1310f86cc.csv', '_blank')
			//url点击时间传过来的路径
			const link = document.createElement("a");
			fetch('https://'+item.url)
			    //因为我的url是--->sheepFiles/79819a1de6b46766f5/abv.txt
			    //没有服务器地址所以需要拼上服务器地址 HOST
			    //拼接后--->http://www.xx.net/sheep/sheepFiles/79819a1de6b46766f5/abv.txt
			    .then((res) => res.blob())
			    .then((blob) => {
			      // 将链接地址字符内容转变成blob地址
			      link.href = URL.createObjectURL(blob);
			      // console.log(link.href)
			      link.download = item.name; // 下载的文件名字
			      document.body.appendChild(link);
			      link.click();
			      document.body.removeChild(link);
			});
			
		},
		
		addDown(){
			this.edit_visible = true
		},
		editModalOk(){
			let that = this
			if(!that.x_source){ // 作品来源
				that.$message.warning('作品来源不能为空');
			}
			else if(!that.x_url){ // 作品链接
				that.$message.warning('作品链接不能为空');
			}
			else {
				libraryDownAdd({
					source: that.x_source,
					url: that.x_url
				}).then(res=>{
					console.log('新建',res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success(res.data.msg || '操作成功');
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		editModalCancel(){
			this.x_source = undefined
			this.x_url = ''
			this.edit_visible = false
		},
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		
	}
}
</script>

<style scoped>

</style>